import axios from "axios";
import { environment } from "environments/environment";
import { onRequestSuccess, onResponseRejected } from "./interceptors";

const initialQuizInstance = axios.create({
    baseURL: `${environment.protocol}${environment.gatewayIp}:${environment.gatewayPort}/fc-initial-quiz/api/v1`
});

initialQuizInstance.interceptors.request.use(onRequestSuccess, undefined);
initialQuizInstance.interceptors.response.use(undefined, onResponseRejected);

export default initialQuizInstance;
